module.exports = __webpack_public_path__ + "media/src/assets/images/menu-c275e5189ecaabdbfdc5407dc031c28b.svg";